import { render, staticRenderFns } from "./CaptainBalance.vue?vue&type=template&id=ba83fd4e&scoped=true"
import script from "./CaptainBalance.vue?vue&type=script&lang=js"
export * from "./CaptainBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba83fd4e",
  null
  
)

export default component.exports